// JobTitleLogic.js
import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const saveJobTitle = async (jobTitle, navigate) => {
    const accesstoken = getToken();
    if (accesstoken) {
        try {
            let Payload = {
                jobtitleID: jobTitle?.jobtitleID || 0,
                titleName: jobTitle?.titleName,
                description: jobTitle?.description || "",
                isActive: jobTitle?.isActive !== undefined ? jobTitle.isActive : true,
            };

            const response = await fetch(`${dev_baseUrl}/Employee/saveJobTitle`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(Payload),
            });

            const data = await response.json();
            if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
                navigate(`/login`);
            } else {
                return data;
            }
        } catch (error) {
            console.error("Network error:", error);
            return {
                isError: true,
                message: "An error occurred. Please try again later.",
                error: error,
            };
        }
    } else {
        console.warn("Access token is not available.");
        return { form: "Access token is missing." };
    }
};

export const getJobTitles = async (navigate) => {
    const accesstoken = getToken();
    if (accesstoken) {
        try {
            const response = await fetch(`${dev_baseUrl}/Employee/getJobTitles`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                    "Content-Type": "application/json",
                },
            });

            const data = await response.json();
            if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
                navigate(`/login`);
            } else {
                return data;
            }
        } catch (error) {
            console.error("Network error:", error);
            return {
                isError: true,
                message: "An error occurred while fetching job titles.",
                error: error,
            };
        }
    } else {
        console.warn("Access token is not available.");
        return { form: "Access token is missing." };
    }
};
// Add this to your JobTitleLogic.js file
export const deleteJobTitle = async (jobtitleID, navigate) => {
    const accesstoken = getToken();
    if (accesstoken) {
        try {
            const response = await fetch(`${dev_baseUrl}/Employee/deleteJobTitle?jobtitleID=${jobtitleID}`, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                    "Content-Type": "application/json",
                },
            });

            const data = await response.json();
            if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
                navigate(`/login`);
            } else {
                return data;
            }
        } catch (error) {
            console.error("Network error:", error);
            return {
                isError: true,
                message: "An error occurred. Please try again later.",
                error: error,
            };
        }
    } else {
        console.warn("Access token is not available.");
        return { form: "Access token is missing." };
    }
};